
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"54","height":"54","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"4","d":"M27 5C14.85 5 5 14.85 5 27s9.85 22 22 22 22-9.85 22-22"}})])
          )
        }
      }
    